function Opcao({ ativo, titulo, texto, onClick, desligada, e2e }) {
  return (
    <button type="button" onClick={onClick} disabled={desligada} data-e2e={e2e} data-ativo={ativo ? "1" : "0"}
      className={`text-left rounded-xl border p-3 transition disabled:opacity-50 disabled:cursor-not-allowed ${ativo ? "border-primary ring-2 ring-primary/30 bg-primary/5" : "hover:border-primary"}`}>
      <p className="text-sm font-semibold">{titulo}</p>
      <p className="text-xs text-muted-foreground mt-0.5">{texto}</p>
    </button>
  );
}

/**
 * Quando o anúncio aparece: só com a loja aberta (pelo horário de funcionamento)
 * ou o dia todo, com o horário dia a dia embaixo. É a mesma peça ao criar a
 * campanha (Impulsionar) e ao trocar depois (cartão da campanha).
 * `horario` vem do servidor: `{ tem, horas_por_semana, dias: [{ dia, faixas }] }`.
 */
export default function HorarioOpcoes({ modo, horario, aoEscolher, prefixo }) {
  const loja = horario || { tem: false, dias: [] };
  return (
    <>
      <div className="grid sm:grid-cols-2 gap-2">
        <Opcao ativo={modo === "funcionamento"} desligada={!loja.tem} onClick={() => aoEscolher("funcionamento")} e2e={`${prefixo}-horario-funcionamento`}
          titulo="Só com a loja aberta" texto={loja.tem ? `Segue o horário de funcionamento: ${Math.round(loja.horas_por_semana)} horas por semana.` : "A loja está como 24 horas (ou sem horário cadastrado), então dá no mesmo que o dia todo."} />
        <Opcao ativo={modo === "dia_todo"} onClick={() => aoEscolher("dia_todo")} e2e={`${prefixo}-horario-dia-todo`}
          titulo="O dia todo" texto="Aparece a qualquer hora, também com a loja fechada. Faz sentido se a loja aceita pedido agendado." />
      </div>
      {modo === "funcionamento" && loja.tem && (
        <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 text-sm" data-e2e={`${prefixo}-dias`}>
          {loja.dias.map((d) => (
            <li key={d.dia} className="flex justify-between gap-3">
              <span className="text-muted-foreground">{d.dia}</span>
              <span className="tabular-nums text-right">{d.faixas.length ? d.faixas.join(" · ") : <span className="text-muted-foreground">não aparece</span>}</span>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
